import React from 'react';
import axios from 'axios';
import './NoticeList.css'; // Import the CSS file

const API_URL = 'https://noticebackend.onrender.com';

const NoticeList = ({ notices, token, fetchNotices }) => {
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/notices/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchNotices();
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  return (
    <div className="notice-list-container">
      <h2 className="notice-list-title">Notice Board</h2>
      {notices.map((notice) => (
        <div key={notice._id} className="notice">
          <h3 className="notice-title">{notice.title}</h3>
          <p className="notice-description">{notice.description}</p>
          {notice.imageURL && (
            <img
              src={`${API_URL}${notice.imageURL}`}
              alt="Notice"
              className="notice-image"
            />
          )}
          <p className="notice-date">{new Date(notice.createdAt).toLocaleString()}</p>
          {token && (
            <button 
              className="delete-button" 
              onClick={() => handleDelete(notice._id)}
            >
              Delete
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default NoticeList;